module.exports = __webpack_public_path__ + "static/media/user_management_darkmode.c23daca5.svg";